export default __webpack_public_path__ + "static/media/ZahrahforDouglasW04-SmBd.31810a24.ttf";